
const HOST = window.location.host;

// const DEVELOP_LOCAL_HOST = 'wendy-form.meishakeji.com';
// const DEVELOP_LOCAL_HOST = 'test-wj.meishakeji.com';
const DEVELOP_LOCAL_HOST = 'test-wjh5.meishakeji.com';

export const ENV = {
  DEV: /^127.0.0.1|^localhost|^192.168|^well/.test(HOST),
  TEST: /^test-/.test(HOST),
  PRE: /^pre-/.test(HOST)
};

/**
 * 根据当前环境，生成项目 api 的地址：BASE_URL
 */
const getBaseUrl = () => {
  let baseUrl = '';
  if (ENV.DEV) {
    baseUrl = `//${DEVELOP_LOCAL_HOST}`;
  } else {
    baseUrl = `//${HOST}`;
  }
  return baseUrl;
};

// API base URL
export const BASE_URL = getBaseUrl();

const API = {
  GET_FORM_QUESTION: '/api/mobile/v1/form/get_form_answer',
  GET_FORM_PREVIEW_QUESTION: '/api/mobile/v1/paper/get',
  SEND_ANSWER: '/api/mobile/v1/form/send_answer',
  COMMIT: '/api/mobile/v1/form/commit',
  UPLOAD_FILE: '/api/common/upload_file',
  GET_STUDENT_LIST: '/api/mobile/v1/account/get_object_user',
  GET_FORM_SETTING: '/api/mobile/v1/form/get_form_setting',
  LOGIN: '/api/mobile/v1/account/login',
  GET_CAPTCHA: '/api/mobile/v1/account/get_captcha',
  WE_CHAT_LOGIN: '/api/mobile/v1/account/we_chat_login',
  GET_OBJECT_USER_BY_ID: '/api/mobile/v1/account/get_object_user_by_id',
  GET_USER_INFO: '/api/mobile/v1/account/get_user_info',
  BIND_PHONE_NO: '/api/mobile/v1/account/bind_phone_no',
  GET_TICKET: '/api/mobile/v1/share/get_ticket'
};
export default API;
